module.exports = __webpack_public_path__ + "img/6e0c556.png";